import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import TextareaAutosize from "react-textarea-autosize";
import styles from "./Input.module.styl";

export default function Input({
    className,
    type,
    textarea,
    value,
    onChange,
    onFocus,
    placeholder,
    isInvalid,
    ...props
}) {
    const classes = cx(styles.input, isInvalid && styles.invalid, className);

    if (textarea) {
        return (
            <TextareaAutosize
                {...props}
                className={classes}
                value={value ?? ""}
                onChange={(e) => onChange(e.target.value)}
                onFocus={onFocus}
                placeholder={placeholder}
            />
        );
    }

    return (
        <input
            {...props}
            className={classes}
            type={type}
            value={value ?? ""}
            onChange={(e) => onChange(e.target.value)}
            onFocus={onFocus}
            placeholder={placeholder}
        />
    );
}

Input.propTypes = {
    className: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    type: PropTypes.string,
    textarea: PropTypes.bool,
    placeholder: PropTypes.string,
    isInvalid: PropTypes.bool,
};

Input.defaultProps = {
    type: "text",
};
